import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.div`
  border-radius: 100%;
  background: ${key('colors.red.default')};
  width: 86px;
  height: 86px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  strong {
    font-size: 18px;
    display: inline-block;
    padding-right: 5px;
  }

  small {
    font-size: 12px;
  }
`;
